export const parseTimestamp = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }

  const time = Date.parse(value);

  return Number.isNaN(time) ? null : time;
};

export const isLiveAt = (
  announcement: { expiresAt?: string | null; publishedAt?: string | null },
  now: Date,
): boolean => {
  const publishedAt = parseTimestamp(announcement.publishedAt);

  if (publishedAt === null || publishedAt > now.getTime()) {
    return false;
  }

  if (!announcement.expiresAt) {
    return true;
  }

  const expiresAt = parseTimestamp(announcement.expiresAt);

  return expiresAt !== null && expiresAt > now.getTime();
};
